import {confirmModal} from "./confirmModal";
import axios from "axios";
import {url} from "./utilities";

const sessionAlert = () => {
    let visibilityTimeout = 60;

    let updateTimeLeftClock;
    let activeClock = true;

    let alertShown = false;

    let container = $(".toasts .toast-container");
    let dom = $(`<div role="alert" class="toast bg-warning border-0 text-white show" style="flex-direction: column; overflow: hidden;"></div>`);
    let toastTimer = $(`
        <div class="toast-timer">
            <div class="toast-timer-clock"></div>
        </div>
    `);
    dom.append(toastTimer);
    dom.append($(`
        <div class="toast-body">
            <strong>Uwaga!</strong> Twoja sesja wygaśnie za <span class="session-time-left"></span>s.<br />
            <a href="#" class="text-white link-underlined session-extend">Kliknij tutaj, aby przedłużyć sesję.</a>
        </div>
    `));

    $('body').on('click', '.session-extend', async function() {
        try {
            const response = await axios.post(url('api/extend-session'));
            window._session_expire_date = response.data.expire_date;

            dom.remove();
            alertShown = false;
            clearInterval(updateTimeLeftClock);
        } catch(err) {
            window.location.reload();
        }
    })

    const updateTimeLeft = () => {
        let timeLeft = window._session_expire_date - (Date.now() / 1000)
        dom.find('.session-time-left').text(Math.ceil(timeLeft));
        toastTimer.find('.toast-timer-clock').css({width: timeLeft/visibilityTimeout*100 + '%'})
    }

    const checkSessionTimeout = async () => {
        if(Date.now() > (window._session_expire_date) * 1000) {
            dom.remove();
            clearInterval(updateTimeLeftClock);
            activeClock = false;

            let result = await confirmModal('Aby kontynuować, musisz odświeżyć stronę.', {
                color: 'danger',
                title: 'Twoja sesja wygasła!',
                buttons: [
                    {
                        type: 'resolve',
                        text: 'Odśwież',
                        color: 'outline-danger',
                    }
                ]
            })

            if(result) {
                window.location.reload();
            }

            return;
        }

        if(Date.now() > (window._session_expire_date - visibilityTimeout) * 1000 && !alertShown) {
            updateTimeLeft();
            container.append(dom);
            alertShown = true;

            updateTimeLeftClock = setInterval(updateTimeLeft, 500)
        }
    }

    const worker = new Worker(new URL('session-worker.js', import.meta.url));
    worker.onmessage = function() {
        if(activeClock) {
            checkSessionTimeout();
        }
    }
    checkSessionTimeout();
}

if(typeof logged_user_id != 'undefined' && logged_user_id != null) {
    sessionAlert();
}
